module.exports = __webpack_public_path__ + "static/094dark-0db0ad415c58c570766d3d6f1fa7473e.jpg";